import * as types from './constants';

// Get Lookbook Order Item
export const getLookbookOrderItemRequest = data => (
  { type: types.GET_LOOKBOOK_ORDER_ITEM_REQUEST, payload: data }
);

export const getLookbookOrderItemDone = data => (
  { type: types.GET_LOOKBOOK_ORDER_ITEM_DONE, payload: data }
);

export const getLookbookOrderItemFailed = errors => (
  { type: types.GET_LOOKBOOK_ORDER_ITEM_FAILED, payload: errors }
);